import { Close } from "@mui/icons-material";
import { Autocomplete, Button, IconButton, TextField } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../store";
import Swal from "sweetalert2";
import { fieldingTypeCreate, fieldingTypeDelete, fieldingTypeGet } from "../../../fielding/fielding.api";
import { useState } from "react";

export default function FieldingTypeForm(props: {
    readOnly: boolean,
    value: string,
    onChange: (params: string) => void
}) {

    const dispatch = useDispatch<any>()

    const typeList = useSelector((state: RootState) => state.fielding).dataTypeList

    const [valueType, setValueType] = useState("")

    const handleAdd = () => {
        dispatch(fieldingTypeCreate(valueType))
            .unwrap()
            .then((response: any) => {
                dispatch(fieldingTypeGet())
                    .unwrap()
                    .then(() => {
                        props.onChange(response.data.data.id)
                    })
            })
    }

    const handleDelete = (type: any) => {
        Swal.fire({
            icon: "question",
            title: `Are you sure want to delete "${type.name}"`,
            showCancelButton: true
        })
            .then(result => {
                if (result.isConfirmed) {
                    dispatch(fieldingTypeDelete(type.id))
                        .unwrap()
                        .then((response: any) => {
                            dispatch(fieldingTypeGet())
                        })
                }
            })
    }

    return (
        <div className="fielding-type">
            <Autocomplete
                fullWidth
                readOnly={props.readOnly}
                options={typeList}
                getOptionLabel={(type) => type.name}
                renderOption={(props, option) => (
                    <li {...props}>
                        <span style={{ width: "100%" }}>
                            {option.name}
                        </span>
                        <IconButton onClick={() => handleDelete(option)}>
                            <Close />
                        </IconButton>
                    </li>
                )}
                value={typeList.filter(type => type.id === props.value)[0] || null}
                onChange={(e, value) => props.onChange(value?.id || "")}
                renderInput={(params) => <TextField {...params} label="Type" onChange={(e) => setValueType(e.target.value)} />}
            />
            <Button variant="contained" disabled={valueType === "" || typeList.filter(data => data.name === valueType).length > 0} onClick={handleAdd}>Save New Type</Button>
        </div>
    )
}